import * as v0 from "@aidkitorg/types/lib/survey";
import { useState, useEffect } from "react";
import { safeParse } from "../Util";

type TestOutcome = {
  title: string,
  passed: boolean,
  output: any
};

export default function TestCases(props: { survey: v0.ExpandedSurvey }) {
  const [computedFields, setComputedFields] = useState<TestOutcome[]>([]);

  useEffect(() => {
    const computedField: v0.Computed[] = [];
    function traverse(node: any) {
      if (Array.isArray(node)) {
        node.map(traverse);
      } else if (typeof node === 'object') {
        if (node.kind === 'Computed') {
          if (Array.isArray(node.testCases)) {
            computedField.push(node);
          }
        } else {
          Object.values(node).map(traverse);
        }
      }
    }
    traverse(props.survey);


    const results: TestOutcome[] = [];
    for (const field of computedField) {
      const testCases = field.testCases!;
      for (const testCase of testCases) {
        try {
          let input: () => Record<string, string> = () => ({} as Record<string, string>);
          if (typeof testCase.input === 'string') {
            input = Function(
              "return (function() { const out = " + testCase.input + "; return out });"
            )();
          } else if (testCase.input.kind === 'Persona') {
            let personaName = testCase.input.persona;
            input = () => (props.survey.personas.find(n => n.name === personaName)?.attrs || [])
              .reduce<Record<string, string>>((acc, cur) => {
                acc[cur.field] = cur.value;
                return acc;
              }, {});
          }
          const func = Function(
            "return (function(info, org, screener) { const out = " + field.formula + "; return out });"
          )();
          const check = Function(
            "return (function(output) { const out = " + testCase.test + "; return out });"
          )();
          const out = func(input());
          const ok = check(out);

          results.push({
            title: `${field.targetField} - ${testCase.description}`,
            passed: ok,
            output: out
          });
        } catch (e) {
          results.push({
            title: `${field.targetField} - ${testCase.description}`,
            passed: false,
            output: "Did not compile: " + e
          });
        }
      }
    }
    setComputedFields(results);


  }, [props.survey]);


  return <>
    <h2>Test Cases</h2>
    {computedFields.length === 0 ? "No test cases found" : null}
    {computedFields.map((f) => {
      let outputJson = safeParse(f.output);
      return <div key={f.title}>
        <h3>{f.title}</h3>
        {f.passed ? "✅ Passed!" : <>
          ❌ Failed!
          {f.output.includes("{") ?
            <pre>
              {JSON.stringify(outputJson, null, 2)}
            </pre> : f.output}
        </>}
      </div>
    })}</>;
}